import React from "react"
import PropTypes from "prop-types"

import "./ImageBlocks.css"

const ImageBlocks = ({ images }) => {

  const imagesToDisplay = []
  for (const image of images) {
    imagesToDisplay.push({
      url: image,
      style: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        height: 'inherit',
        backgroundImage: `url(${require(`../../images/${image}`)})`,
        margin: '5px',
        transition: 'width .4s ease-in-out',
      },
    })
  }

  return (
    <div className="ImageBlocks ImageBlocks__Container">
      {imagesToDisplay.map((image, index) => (
        <div key={index} style={image.style} className="ImageBlocks__Block"></div>
      ))}
    </div>
  )
}

ImageBlocks.propTypes = {
  images: PropTypes.array.isRequired,
}

export default ImageBlocks
